/* global axios */

import ApiClient from './ApiClient';

class KanbanSharedAccessAPI extends ApiClient {
  constructor() {
    super('kanban_items', { accountScoped: true });
  }

  urlFor(itemId) {
    return `${this.url}/${itemId}/shared_accesses`;
  }

  get(itemId) {
    return axios.get(this.urlFor(itemId));
  }

  create(itemId, sharedAccess) {
    return axios.post(this.urlFor(itemId), {
      shared_access: sharedAccess,
    });
  }

  update(itemId, sharedAccessId, sharedAccess) {
    return axios.patch(`${this.urlFor(itemId)}/${sharedAccessId}`, {
      shared_access: sharedAccess,
    });
  }

  delete(itemId, sharedAccessId) {
    return axios.delete(`${this.urlFor(itemId)}/${sharedAccessId}`);
  }
}

export default new KanbanSharedAccessAPI();
